<div class="form-button-container">
    <button mat-flat-button class="submit-button" 
        [ngClass]="'form-button-' + formButton.ButtonStatus" (click)="onClickEvent();" [type]="type" color="accent" 
        [disabled]="isDisabled || formButton.isSubmitting">
            {{ formButton.ButtonText }}
        <mat-icon matSuffix>{{formButton.ButtonIcon}}</mat-icon>
    </button>
    <span *ngIf="formButton.ErrorMessage != undefined" class="form-button-error-message">{{formButton.ErrorMessage}}</span>
    <mat-progress-bar *ngIf="formButton.isSubmitting" mode="indeterminate"></mat-progress-bar>
</div>
